module.exports = __webpack_public_path__ + "static/media/Tour2.3998bfa1.jpeg";